import { useCallback, useState } from "react";
import { URL, apiURL } from "../../../utils/constant";
import Api from "../../../utils/api.utils";
import Joi from "joi";

import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  setApiData,
  setEProcode,
  setLoginData,
  setPatientData,
} from "../../reducer/auth.reducer";
import {
  hidePageLoader,
  showPageLoader,
} from "../../reducer/pageLoader.reducer";
import { setToken } from "../../reducer/appState.reducer";
import { size } from "lodash";
const StudyName = "CREATE-1";

export const authSchema = Joi.object({
  MobileNo: Joi.string().min(10).required().messages({
    "string.empty": "Contact number Should not be Empty",
    "string.min": "Enter a valid Contact Number",
  }),
  verifyOtp: Joi.string().min(5).required(),
});
export function useAuth() {
  const [isActive, setIsActive] = useState(true);
  const [SubjectDetails, setSubjectDetails] = useState([]);
  const dispatch = useDispatch();

  const login = useCallback(async ({ MobileNo }) => {
    dispatch(showPageLoader());
    try {
      const { data } = await Api.get({
        url: apiURL.sendVerification(),
        params: {
          MobileNo,
          StudyName: StudyName,
        },
      });
      // console.log("apidataSendOTP ::: ", data);
      dispatch(hidePageLoader());
      return data;
    } catch (err) {
      dispatch(hidePageLoader());
    }
  }, []);

  const eproCodeLogin = useCallback(async (verifyOtp) => {
    dispatch(showPageLoader());
    try {
      const { data } = await Api.get({
        url: apiURL.sendeProCode(),
        params: {
          eProCode: verifyOtp,
        },
      });
      if (size(data) > 0) {
        dispatch(setEProcode(verifyOtp));
      }
      setSubjectDetails(data[0]);
      dispatch(setPatientData(data[0]));
      dispatch(setApiData(data[0]));
      dispatch(hidePageLoader());
      return data;
    } catch (err) {
      dispatch(hidePageLoader());
    }
  }, []);

  const verifyOTPApi = useCallback(async ({ MobileNo, verifyOtp }) => {
    try {
      dispatch(showPageLoader());
      const { data } = await Api.get({
        url: apiURL.verifyOTP(),
        params: {
          MobileNo,
          VerificationCode: verifyOtp,
        },
      });
      dispatch(hidePageLoader());

      dispatch(setApiData(data));

      return data;
    } catch (error) {
      dispatch(hidePageLoader());
      console.log("err==>", error);
    }
  }, []);

  return {
    SubjectDetails,
    login,
    eproCodeLogin,
    verifyOTPApi,
  };
}
